module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-content fadeInRight animated tabBox",
    attrs: {
      "id": "carfile-detail"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus != 2 && _vm.loadingbasicstatus),
      expression: "loadingstatus!=2 && loadingbasicstatus"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("车辆ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.vehicleName),
      expression: "vehicleInfo.vehicleName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.vehicleInfo.vehicleName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "vehicleName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("服务卡号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.vehicleAccount),
      expression: "vehicleInfo.vehicleAccount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.vehicleInfo.vehicleAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "vehicleAccount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("当前里程")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.totalMileage),
      expression: "vehicleInfo.totalMileage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.vehicleInfo.totalMileage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "totalMileage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [(_vm.permission.indexOf('carFileList_calibrate') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openSubPage
    }
  }, [_vm._v("校准")]) : _vm._e()])])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("当前所在城市")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.posCity),
      expression: "vehicleInfo.posCity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.vehicleInfo.posCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "posCity", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "gray-bg pb5px"
  }, [_c('ul', {
    staticClass: "col-sm-12 pl0px pt0px tip_page_tabs",
    staticStyle: {
      "overflow": "hidden"
    }
  }, _vm._l((_vm.subTabList), function(subTab, index) {
    return _c('li', {
      staticClass: "t_center",
      class: {
        active: _vm.currentIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.goSubTab(index, subTab.route)
        }
      }
    }, [_c('a', {
      domProps: {
        "textContent": _vm._s(subTab.name)
      }
    })])
  }), 0), _vm._v(" "), _c('keep-alive', [(_vm.resultVehicle.vehicleId) ? _c(_vm.currentView, {
    tag: "component",
    staticStyle: {
      "clear": "both"
    }
  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('tab-modal', {
    ref: "modalMsg",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": _vm.closeModal
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.messageStr) + "\n\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.closeModal('modalMsg')
      }
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('sub-page', {
    attrs: {
      "show": _vm.toShow,
      "bigTitleMsg": _vm.bigTitle,
      "scroll": _vm.scrollTop,
      "width": 30
    },
    on: {
      "cancel": _vm.closeSubPage
    }
  }, [_c('div', {
    attrs: {
      "slot": "bodycontent"
    },
    slot: "bodycontent"
  }, [_c('div', {
    staticClass: "m20px"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("请输入当前车辆实际里程")]), _vm._v(" "), _c('input-number', {
    attrs: {
      "min": 1,
      "max": 1000000,
      "controls": false,
      "inputWidth": 200
    },
    model: {
      value: (_vm.mileageNum),
      callback: function($$v) {
        _vm.mileageNum = $$v
      },
      expression: "mileageNum"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [(_vm.permission.indexOf('carFileList_calibrateSure') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.correctMileage
    }
  }, [_vm._v("确定")]) : _vm._e()])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-687e908d","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/carfile/PageCarFileDetail.vue
// module id = 1552
// module chunks = 0